import { Directive, forwardRef } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";
const CURP_VALIDATE_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => CurpValidateValidator),
  multi: true
};
@Directive({
  selector: '[curpvalidate]',
  providers: [ CURP_VALIDATE_VALIDATOR ],
})
export class CurpValidateValidator implements Validator {
  validate(control: AbstractControl): {[key: string]: any} {
    if (control.value != null || typeof control.value === 'string' && control.value.length !== 0) {
      return this.curpValidation(control.value) ? null : { 'invalidCurp': true };
    } else {
      return null;
    }
  }
  private curpValidation(curp: string): boolean {
    var re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
      validated = curp.match(re);

    if (!validated)  //Coincide con el formato general?
      return false;

    //Validar que coincida el dígito verificador
    if (validated[2] != this.checkDigit(validated[1]).toString())
      return false;

    return true; //Validado
  }
  private  checkDigit(curp17: string) {
    //Fuente https://consultas.curp.gob.mx/CurpSP/
    var dictionary = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
      lngSum = 0.0,
      lngDigit = 0.0;
    for (var i = 0; i < 17; i++)
      lngSum = lngSum + dictionary.indexOf(curp17.charAt(i)) * (18 - i);
    lngDigit = 10 - lngSum % 10;
    if (lngDigit == 10) return 0;
    return lngDigit;
  }
}